const DeleteCheckListWarningModal = (props) => {
  const { selectedCheckList, deleteCheckListPromise } = props;
  return (
    <>
      <div
        className="modal centered delete-modal fade"
        id="deleteCheckListWarningModal"
        tabindex="-1"
        aria-labelledby="deleteCheckListWarningModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered ">
          <div className="modal-content">
            <div className="modal-body" style={{ height: "unset" }}>
              <p
                style={{
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "600",
                }}
              >
                Are you sure you want to delete this project checklist ?
              </p>
            </div>
            <div className="modal-footer">
              <button
                style={{ width: "55px", height: "42px" }}
                type="button"
                className="btn btn-secondary"
                data-bs-toggle="modal"
              >
                No
              </button>
              <button
                type="button"
                className="btn primary-btn ok-btn"
                data-bs-toggle="modal"
                onClick={() => {
                  deleteCheckListPromise(selectedCheckList?.id);
                }}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeleteCheckListWarningModal;
